import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'
import { TaskDueAllDay } from '../CRMIntegrationTaskSettings'

export type RedtailInboundContactSyncSettingsFilters = {
  type?: string[]
  status_id?: string[]
  category_id?: string[]
}

export type RedtailInboundContactSyncSettings = {
  autoSync: boolean
  filters: RedtailInboundContactSyncSettingsFilters
  tierCategories?: string[]
}

export type RedtailInboundCalendarSyncSettings = {
  enabled: boolean
}

export type RedtailInboundSyncSettings = {
  contact: RedtailInboundContactSyncSettings
  calendar: RedtailInboundCalendarSyncSettings
}

export type RedtailSettingsFormValues = {
  inbound: RedtailInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
  taskDueAllDay: TaskDueAllDay
}

const defaultTime = new Date()
defaultTime.setUTCHours(16, 0, 0, 0)

export const redtailSettingsDefaultValues: RedtailSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
    calendar: {
      enabled: false,
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
  taskDueAllDay: {
    allDay: false,
    date: defaultTime,
  },
}
